<template>

  <div style="max-width: 80%; margin: 2em;">
    
  <div v-if="dataLoaded">
     <div class="row">
      <div class="col s4 offset-s8" style="padding: 25px;">
        <a type="submit" :href="'/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/primary_inspections/' + this.$route.params.primary_inspection_id+'.pdf'" style="margin: 15px;" class="btn btn-small green"><i  class="material-icons right">print</i>{{$t('menu.buttons.print')}}</a>
        <a v-if="primaryInspection.editable" type="button" style="margin: 15px;" :href="'#/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/primary_inspections/' + this.$route.params.primary_inspection_id+'/edit'" class="waves-effect waves-light btn-large emptygreen">{{$t('menu.buttons.edit')}}</a>
      </div>
    </div>
  <div class="print-only">
      <img :src="logo" style="max-width: 80%;" />
    </div>

    <h1>{{ $t('primary_inspections.title') }}</h1>
    <p>{{ $t('primary_inspections.date') }} {{ formatDate(primaryInspection.created_at) }}</p>

    <table class="highlight">
      <thead>
        <tr>
          <th colspan="4">{{ $t('primary_inspections.company_info') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>{{ $t('primary_inspections.name') }}</strong></td>
          <td colspan="3">{{ primaryInspection.place.customer.name }}</td>
        </tr>
        <tr>
          <td><strong>{{ $t('primary_inspections.address') }}</strong></td>
          <td colspan="3">{{ primaryInspection.place.customer.address.street }}</td>
        </tr>
        <tr>
          <td><strong>{{ $t('primary_inspections.postal_code') }}</strong></td>
          <td>{{ primaryInspection.place.customer.address.postal_code }}</td>
          <td><strong>{{ $t('primary_inspections.city') }}</strong></td>
          <td>{{ primaryInspection.place.customer.address.city }}</td>
        </tr>
        <tr>
          <td><strong>{{ $t('primary_inspections.nip') }}</strong></td>
          <td>{{ primaryInspection.place.customer.nip }}</td>
          <td><strong>{{ $t('primary_inspections.regon') }}</strong></td>
          <td>{{ primaryInspection.place.customer.regon }}</td>
        </tr>
        <tr>
          <td><strong>{{ $t('primary_inspections.krs') }}</strong></td>
          <td>{{ primaryInspection.place.customer.krs }}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <th colspan="4">{{ $t('primary_inspections.place_info') }}</th>
        </tr>
        <tr>
          <td><strong>{{ $t('primary_inspections.name') }}</strong></td>
          <td colspan="3">{{ primaryInspection.place.name }}</td>
        </tr>
        <tr>
          <td><strong>{{ $t('primary_inspections.address') }}</strong></td>
          <td colspan="3">{{ primaryInspection.place.address.street }}</td>
        </tr>
        <tr>
          <td><strong>{{ $t('primary_inspections.postal_code') }}</strong></td>
          <td>{{ primaryInspection.place.address.postal_code }}</td>
          <td><strong>{{ $t('primary_inspections.city') }}</strong></td>
          <td>{{ primaryInspection.place.address.city }}</td>
        </tr>
      </tbody>
    </table>

    <div v-for="detail in sortedDetails" :key="detail.id">
      <br/>
      <table class="striped">
        <thead>
          <tr>
            <th colspan="3" class="center-align">{{ detail.group.name | capitalize }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="3">
              {{ detail.pests.length === 0 && !detail.other
                ? $t('primary_inspections.not_specified_pests')
                : Array.from(new Set([...detail.pests.map(p => p.tags.map(tag => tag.name)).flat(), detail.other || '']))
                .filter(c => c)
                .sort((a, b) => a.localeCompare(b))
                .join(', ')

             }}
            </td>
          </tr>
          <tr>
            <td><strong>{{ $t('primary_inspections.probability') }}</strong></td>
            <td colspan="2">{{ $t('primary_inspections.risk_list.'+detail.risk) }}</td>
          </tr>
          <tr>
            <td><strong>{{ $t('primary_inspections.active_periods') }}</strong></td>
            <td colspan="2">
              {{ detail.periods.length === 0
                ? $t('primary_inspections.not_specified')
                : detail.periods.map(p => $t('primary_inspections.'+p)).join(', ') }}
            </td>
          </tr>
          <tr>
            <td><strong>{{ $t('primary_inspections.activity') }}</strong></td>
            <td colspan="2">{{ $t('primary_inspections.activity_list.'+detail.activity) }}</td>
          </tr>
          <tr>
            <td><strong>{{ $t('primary_inspections.where') }}</strong></td>
            <td colspan="2">{{ detail.where }}</td>
          </tr>
          <tr>
            <td><strong>{{ $t('primary_inspections.conditions') }}</strong></td>
            <td colspan="2">{{ detail.notions }}</td>
          </tr>
          <tr>
            <td><strong>{{ $t('primary_inspections.advices') }}</strong></td>
            <td colspan="2">{{ detail.advices }}</td>
          </tr>
          <tr>
            <td><strong>{{ $t('primary_inspections.observation') }}</strong></td>
            <td colspan="2">{{ $t('primary_inspections.under_observation_list.'+detail.under_observation) }}</td>
          </tr>
          <tr>
            <td><strong>{{ $t('primary_inspections.decided_monitoring') }}</strong></td>
            <td colspan="2">{{ $t('primary_inspections.observation_list.'+detail.observation) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else>
     <preloader n="7"/>
  </div>
</div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    customer_id: String,
    place_id: String,
    primary_inspection_id: String,
  },
  data() {
    return {
      place: null,
      primaryInspection: null,
      dataLoaded: false,
    };
  },
  computed: {
    sortedDetails() {
      return this.primaryInspection.details.sort((a, b) => {
        const aGroup = a.group.no ? a.group.no.toString() : a.group.name;
        const bGroup = b.group.no ? b.group.no.toString() : b.group.name;
        return aGroup.localeCompare(bGroup);
      });
    },
    logo(){
        var complogo = this.primaryInspection.company.header_graphics;
        return "data:image/svg+xml;base64,"+btoa(encodeURIComponent(complogo).replace(/%([0-9A-F]{2})/g,
            function(_, p1){ return String.fromCharCode('0x' + p1) }
          )) ;
    },
  },
  methods: {
    async fetchData() {
      const url = `/customers/${this.$route.params.customer_id}/places/${this.$route.params.place_id}/primary_inspections/${this.$route.params.primary_inspection_id}.json`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        this.primaryInspection = data;
        this.dataLoaded = true;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    formatDate(date) {
      return moment(date).format("LL");
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
  table, tr, td{
    border: 1px solid rgba(0, 0, 0, 1);
    table-layout: fixed;
     word-wrap: break-word;

  }
  .btn-large{
      border-radius: 8px;
      background-color: white;
      color: black;
      border-color: #00CC66;
      border-width: 1px;
      border-style: solid;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 36px;
      line-height: 36px;
  }
  .btn-small {
    margin: 15px !important;
    height: 36px !important;
    line-height: 36px !important;
  }
</style>
